export const Hash = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_5593)">
<path d="M7.4613 11.0496H25.7149" stroke="currentColor" stroke-width="2"/>
<path d="M5.60059 21.0496L23.6006 21.0496" stroke="currentColor" stroke-width="2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.2465 26.9988L21.8285 3.99487L23.9223 4.00274L17.3325 26.9988L15.2465 26.9988Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.01306 26.9988L14.5951 3.99487L16.6888 4.00274L10.099 26.9988L8.01306 26.9988Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1_5593">
<rect width="20" height="23" fill="white" transform="translate(5.60059 4.04956)"/>
</clipPath>
</defs>
</svg>`;
